export default __webpack_public_path__ + "static/Skisser-63e3aab48622d0704f6570b20b9aa608.png";